import ArrowBack from "@mui/icons-material/ArrowBackOutlined";
import Home from "@mui/icons-material/HomeOutlined";
import {Box, Button, Stack, Typography} from "@mui/material";

import {useAuthenticatedUser} from "hooks/useAuth";
import type {FC} from "react";
import {
  isRouteErrorResponse,
  Navigate,
  useLocation,
  useNavigate,
  useRouteError,
} from "react-router";
const boxStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100dvh",
  bgcolor: "#f2f5fa",
  p: 2,
};
type ErrorPageProps = {
  message?: string;
};

const ErrorPage: FC<ErrorPageProps> = ({message}) => {
  const error = useRouteError();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname;
  const user = useAuthenticatedUser();

  const errorMessage =
    message ||
    (isRouteErrorResponse(error)
      ? "This page does not exist."
      : "An unexpected error occurred.");

  if (!user) {
    return <Navigate to="/" state={{from: location}} replace />;
  }

  return (
    <Box sx={boxStyles}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h2" fontWeight={900}>
          Oops!
        </Typography>

        <Typography variant="body1" color="text.secondary" align="center">
          {errorMessage}
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            size="large"
            startIcon={<ArrowBack />}
            onClick={() => navigate(from || "/")}>
            Go Back
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<Home />}
            onClick={() => navigate("/")}>
            Go Home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ErrorPage;
